
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
    Avatar,
    Stack,
    Tooltip
} from "@mui/material";

// App Imports

import { getAllBatches} from "./BatchClient";
import {changeBatch} from "./batchSlice";
import ContractSectionMenu from "../Menus/ContractSectionMenu";
import BatchDrawer from "./BatchDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import {BatchGridColumns} from "./BatchGridColumns";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";

// main function
export default function BatchGrid() {

    // ****************** BEGIN STATES ****************************

    const [batches, setBatches] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [batchDrawerMode, setBatchDrawerMode] = React.useState([]);
    const [batchDrawerState, setBatchDrawerState] = React.useState(false);
    const [configsVisible, setConfigsVisible] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [searchVisible, setSearchVisible] = React.useState(false);
    const [showControls, setShowControls] = useState(true);
    const [showCRUD, setShowCRUD] = useState(true);

    // ****************** END STATES ****************************


    const dispatchData = useDispatch();


    // ****************** BEGIN FETCH ****************************

    const fetchBatches = () =>
        getAllBatches()

            .then(data => {
                console.log(data);
                setBatches(data);
            })


    // ****************** END FETCH ****************************


    // ****************** BEGIN USE EFFECTS *********************

    useEffect(() => {
        fetchBatches();
    }, []);

    // ***************** END USE EFFECTS ***********************

    // ***************** BEGIN MISC ***************************

    const renderBatches = batches => {
        if (batches.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }

    // *************** END MISC *******************************


    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeBatch({id: 0, type: "", started: "", startReason: "" }));
        setBatchDrawerMode("Add");
        setBatchDrawerState(!batchDrawerState);
    };

    // ****************** END CRUD ***********************************


    // *********************** BEGIN STORE ********************************

    const selectorBatchId = useSelector((state) => state.batchSlc.value.id);
    const selectorBatchType = useSelector((state) => state.batchSlc.value.type);
    const selectorBatchStarted = useSelector((state) => state.batchSlc.value.started);
    const selectorBatchStartReason = useSelector((state) => state.batchSlc.value.startReason);

    // ********************** END STORE ********************************


    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectBatchId,selectType, selectStarted, selectStartReason, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeBatch({id: selectBatchId, type: selectType, started: selectStarted, startReason: selectStartReason }));
    }

    // ****************** END DRILLDOWN ****************************



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            {/*<Box sx={{height: 60, pt: 1, pl: 3}}>*/}
            {/*<Badge*/}
            {/*    overlap="circular"*/}
            {/*    anchorOrigin={{*/}
            {/*        vertical: "top",*/}
            {/*        horizontal: "right"*/}
            {/*    }}*/}
            {/*    sx={{*/}
            {/*        "& .MuiBadge-badge": {*/}
            {/*            transform: "translate(65%, -55%)"  // default ≈ 50%, adjust as needed*/}
            {/*        }*/}
            {/*    }}*/}
            {/*    badgeContent={*/}
            {/*        <Avatar*/}
            {/*            sx={{*/}
            {/*                width: 12,*/}
            {/*                height: 12,*/}
            {/*                fontSize: 12,*/}
            {/*                bgcolor: "grey.800"*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            s*/}
            {/*        </Avatar>*/}
            {/*    }*/}
            {/*>*/}
            {/*    <Avatar*/}
            {/*        sx={{*/}
            {/*            bgcolor: "error.main",   // red*/}
            {/*            width: 20,*/}
            {/*            height: 20,*/}
            {/*            fontSize: 14*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        a*/}
            {/*    </Avatar>*/}
            {/*</Badge>*/}
            {/*</Box>*/}
            {/*<Stack direction={"horizontal"}>*/}
            {/*    <Box sx={{width: 20}}/>*/}
            {/*<Badge*/}
            {/*    overlap="circular"*/}
            {/*    anchorOrigin={{*/}
            {/*        vertical: "top",*/}
            {/*        horizontal: "left"*/}
            {/*    }}*/}
            {/*    sx={{*/}
            {/*        "& .MuiBadge-badge": {*/}
            {/*            transform: "translate(-65%, -55%)"*/}
            {/*        }*/}
            {/*    }}*/}
            {/*    badgeContent={*/}
            {/*        <Avatar*/}
            {/*            sx={{*/}
            {/*                width: 12,*/}
            {/*                height: 12,*/}
            {/*                fontSize: 12,*/}
            {/*                bgcolor: "primary.main"*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            L*/}
            {/*        </Avatar>*/}
            {/*    }*/}
            {/*>*/}
            {/*    <Badge*/}
            {/*        overlap="circular"*/}
            {/*        anchorOrigin={{*/}
            {/*            vertical: "top",*/}
            {/*            horizontal: "right"*/}
            {/*        }}*/}
            {/*        sx={{*/}
            {/*            "& .MuiBadge-badge": {*/}
            {/*                transform: "translate(65%, -55%)"*/}
            {/*            }*/}
            {/*        }}*/}
            {/*        badgeContent={*/}
            {/*            <Avatar*/}
            {/*                sx={{*/}
            {/*                    width: 12,*/}
            {/*                    height: 12,*/}
            {/*                    fontSize: 12,*/}
            {/*                    bgcolor: "grey.800"*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                R*/}
            {/*            </Avatar>*/}
            {/*        }*/}
            {/*    >*/}
            {/*        <Avatar*/}
            {/*            sx={{*/}
            {/*                bgcolor: "error.main",*/}
            {/*                width: 20,*/}
            {/*                height: 20,*/}
            {/*                fontSize: 14*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            A*/}
            {/*        </Avatar>*/}
            {/*    </Badge>*/}
            {/*</Badge>*/}
            {/*    <Box sx={{width: 20}}/>*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            position: "relative",*/}
            {/*            display: "inline-block",*/}
            {/*            width: 20,*/}
            {/*            height: 20*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        /!* LEFT badge *!/*/}
            {/*        {(1 === 1) &&*/}
            {/*        <Badge*/}
            {/*            overlap="circular"*/}
            {/*            anchorOrigin={{*/}
            {/*                vertical: "top",*/}
            {/*                horizontal: "left"*/}
            {/*            }}*/}
            {/*            sx={{*/}
            {/*                position: "absolute",*/}
            {/*                inset: 0,*/}
            {/*                "& .MuiBadge-badge": {*/}
            {/*                    transform: "translate(-50%, -50%)"*/}
            {/*                }*/}
            {/*            }}*/}
            {/*            badgeContent={*/}

            {/*                <Avatar*/}
            {/*                    sx={{*/}
            {/*                        width: 12,*/}
            {/*                        height: 12,*/}
            {/*                        fontSize: 12,*/}
            {/*                        bgcolor: "primary.warning"*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    t*/}
            {/*                </Avatar>*/}
            {/*            }*/}
            {/*        />}*/}

            {/*        /!* RIGHT badge *!/*/}
            {/*        <Badge*/}
            {/*            overlap="circular"*/}
            {/*            anchorOrigin={{*/}
            {/*                vertical: "top",*/}
            {/*                horizontal: "right"*/}
            {/*            }}*/}
            {/*            sx={{*/}
            {/*                position: "absolute",*/}
            {/*                inset: 0,*/}
            {/*                "& .MuiBadge-badge": {*/}
            {/*                    transform: "translate(50%, -50%)"*/}
            {/*                }*/}
            {/*            }}*/}
            {/*            badgeContent={*/}
            {/*                <Avatar*/}
            {/*                    sx={{*/}
            {/*                        width: 12,*/}
            {/*                        height: 12,*/}
            {/*                        fontSize: 10,*/}
            {/*                        bgcolor: "grey.800"*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    R*/}
            {/*                </Avatar>*/}
            {/*            }*/}
            {/*        />*/}

            {/*        /!* MAIN avatar *!/*/}
            {/*        <Avatar*/}
            {/*            sx={{*/}
            {/*                bgcolor: "error.main",*/}
            {/*                width: 20,*/}
            {/*                height: 20,*/}
            {/*                fontSize: 14*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            A*/}
            {/*        </Avatar>*/}
            {/*    </Box>*/}
            {/*</Stack>*/}
            <Box sx={{height: 60, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <h3>Batches</h3>
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 3, ml: 2}}  color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                </Stack>
            </Box>
            {/*{showCRUD && <ContractSectionMenu/>}*/}
            <ContractSectionMenu/>
            <BatchDrawer
                batchDrawerMode = {batchDrawerMode}
                batchDrawerState = {batchDrawerState}
                fetchBatches = {fetchBatches}
            />
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Batches"}
                rows={batches}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={BatchGridColumns()}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                // I just added back in rowKey from the AmigosCode example, which should define batch and batch.id
                // this is needed for identifying which batch to delete or edit
                rowKey={batch => batch.id}
                components={{
                    // Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



